"use strict";

// countup.js
(() => {
  const DURATION = 1200;
  const SHOW_CLASS = "js-show";
  const HOST_SELECTOR = ".u-animation--fadeIn";

  // 終わりに向かって減速する（数字が跳ねて見えないように）
  const easeOut = (ratio) => 1 - Math.pow(1 - ratio, 3);

  // 桁が増えたときに幅が動かないよう、最終表示の幅で固定してから始める
  const lockWidth = (el) => {
    const width = el.getBoundingClientRect().width;

    if (!width) return;

    el.style.display = "inline-block";
    el.style.minWidth = `${width}px`;
    el.style.textAlign = "center";
  };

  const countUp = (el, target, finalText) => {
    lockWidth(el);
    el.textContent = "0";

    let startedAt = 0;

    const step = (now) => {
      if (!startedAt) startedAt = now;

      const ratio = Math.min((now - startedAt) / DURATION, 1);

      if (ratio < 1) {
        el.textContent = `${Math.round(target * easeOut(ratio))}`;
        window.requestAnimationFrame(step);
        return;
      }

      // 最後は入力された文字列そのものに戻す（「00」のような表記を保つため）
      el.textContent = finalText;
    };

    window.requestAnimationFrame(step);
  };

  // フェードインと同じ合図（js-show）で走らせ、帯の伸びと足並みをそろえる
  const runOnShow = (host, run) => {
    if (!host || host.classList.contains(SHOW_CLASS)) {
      run();
      return;
    }

    const observer = new MutationObserver(() => {
      if (!host.classList.contains(SHOW_CLASS)) return;

      observer.disconnect();
      run();
    });

    observer.observe(host, { attributes: true, attributeFilter: ["class"] });
  };

  const setUpCountUp = () => {
    const targets = document.querySelectorAll("[data-countup]");

    if (!targets.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    targets.forEach((el) => {
      const target = parseFloat(el.getAttribute("data-countup"));

      if (!Number.isFinite(target) || target <= 0) return;

      const finalText = el.textContent;

      runOnShow(el.closest(HOST_SELECTOR), () => countUp(el, target, finalText));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setUpCountUp, { once: true });
  } else {
    setUpCountUp();
  }
})();
